import React, { useEffect, useRef, useState } from 'react';
import './index.css';
import { widget } from '../../charting_library';
import Datafeed from '../../mydatafeed/datafeed';
import { API_URL } from '../../api-config.js';

import axios from 'axios';
const token = localStorage.getItem("token");
import { toast } from 'react-toastify';

	function saveChart(tvWidget, chartName, POST_OR_PUT, selectedChart) {
		return new Promise((resolve, reject) => {
		let ruta;
	
		if (POST_OR_PUT === 'POST') {
			ruta = 'create_chart';
		} else if (POST_OR_PUT === 'PUT') {
			ruta = `update_chart/${selectedChart.id}`;
		}
	
		// Guardar el gráfico con tvWidget
		tvWidget.save((chartObject) => {
			// Realizar la petición con axios
			axios({
				method: POST_OR_PUT,
				url: `${API_URL}/trading-api/charts/${ruta}`,
				headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${token}`,
				},
				data: {
				chart: JSON.stringify(chartObject),
				chartName: chartName,
				},
			})
			.then(response => {
				resolve(response.data); // Resolver la promesa con los datos de la respuesta
			})
			.catch(error => {
				reject(error); // Rechazar la promesa con el error
			});
		});
		});
	}


const deleteChart = (chartId) => {
	fetch(`${API_URL}/trading-api/charts/delete_chart/${chartId}`, {
		method: 'DELETE',
		headers: {
			'Authorization': `Bearer ${token}`
		},
	})
		.then(response => response.json())
		.then(
			toast.success("Configuración eliminada con éxito.")
		)
		.catch((error) => {
			console.error('Error:', error);
		});
}


const confirmDelete = (chart) => {
	const isConfirmed = window.confirm(`¿Estás seguro de que deseas eliminar la configuración ${chart.name}?`);
	if (isConfirmed) {
		deleteChart(chart.id);
	}
}

async function loadChart(setCharts) {
	try {
		const userResponse = await fetch(`${API_URL}/trading-api/charts/load_charts_by_user/`, {
			headers: {
				'Authorization': `Bearer ${token}`
			},
		});

		// Verificar si la respuesta es 401
		if (userResponse.status === 401) {
			localStorage.removeItem('token'); // Elimina el token
			window.location.href = '/'; // Redirige a la página de login
			return; // Detener la ejecución de la función
		}

		const userCharts = await userResponse.json();

		const adminResponse = await fetch(`${API_URL}/trading-api/charts/load_charts_by_admin`, {
			headers: {
				'Authorization': `Bearer ${token}`
			},
		});

		// Verificar si la respuesta es 401
		if (adminResponse.status === 401) {
			localStorage.removeItem('token');
			window.location.href = '/';
			return;
		}

		const adminCharts = await adminResponse.json();

		setCharts({ userCharts, adminCharts });

	} catch (error) {
		console.error('Error:', error);
	}
}

function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

let disabledFeatures = ['use_localstorage_for_settings', 'header_saveload'];

const supported_resolutions = ['5', '30', '1H']
export const TVChartContainer = () => {
	const [charts, setCharts] = useState({ userCharts: [], adminCharts: [] });
	const [isSavePopupOpen, setIsSavePopupOpen] = useState(false);
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const [chartName, setChartName] = useState('');
	const [tvWidget, setTvWidget] = useState(null);
	const [selectedChart, setSelectedChart] = useState(null);
	const [isFullscreen, setIsFullscreen] = useState(window.innerWidth < 508);
	const [isLoading, setIsLoading] = useState(false);


	const chartContainerRef = useRef();
	const defaultProps = {
		symbol: 'USDCLP',
		interval: '5',
		datafeedUrl: 'https://demo_feed.tradingview.com',
		libraryPath: '/charting_library/',
		chartsStorageUrl: 'https://saveload.tradingview.com',
		chartsStorageApiVersion: '1.1',
		clientId: 'https://www.qrtsolutions.com',
		//userId: userType,
		fullscreen: isFullscreen,
		autosize: false,
	};

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth < 500) {
				setIsFullscreen(true);
			} else {
				setIsFullscreen(false);
			}
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		const widgetOptions = {
			symbol: defaultProps.symbol,
			datafeed: Datafeed,
			interval: defaultProps.interval,
			container: chartContainerRef.current,
			library_path: defaultProps.libraryPath,
			theme: "dark",
			style: "1",
			timezone: "America/Santiago",
			locale: getLanguageFromURL() || 'en',
			disabled_features: disabledFeatures,
			enabled_features: ['study_templates'],
			charts_storage_url: defaultProps.chartsStorageUrl,
			charts_storage_api_version: defaultProps.chartsStorageApiVersion,
			client_id: defaultProps.clientId,
			user_id: defaultProps.userId,
			fullscreen: defaultProps.fullscreen,
			autosize: defaultProps.autosize,
			height: '85%',
			width: '95%',
			supported_resolutions: supported_resolutions,
			compare: {
				symbols: [
					{
						symbol: "DXY", 
						title: "Dólar Index"
					},
				]
			}
		};

		const tvWidget = new widget(widgetOptions);
		setTvWidget(tvWidget);
		
		tvWidget.onChartReady(() => {
			loadChart(setCharts);
			// tvWidget.styleChart().setChartStyle(3); // Establece el estilo de gráfico a velas
				
			const saveButton = tvWidget.createButton();
			saveButton.setAttribute('title', 'Click to Save Chart');
			saveButton.classList.add('apply-common-tooltip');
			saveButton.addEventListener('click', () => {
				setIsSavePopupOpen(true);
			});
			saveButton.innerHTML = 'Guardar Configuraciones';

			const loadButton = tvWidget.createButton();
			loadButton.setAttribute('title', 'Click to Load Chart');
			loadButton.classList.add('apply-common-tooltip');
			loadButton.addEventListener('click', async () => {
				if (!isLoading) {
					setIsLoading(true);
					try {
						await loadChart(setCharts);
						setIsPopupOpen(true);
					} catch (error) {
						console.error('Error loading chart:', error);
					} finally {
						setIsLoading(false);
					}
				}
			});
			loadButton.innerHTML = 'Cargar Configuraciones';
		});

		window.removeEventListener('resize', handleResize);
	}, []);

	const closePopup = () => {
		setIsPopupOpen(false);
	};

	const handleChartSelection = (chart) => {
		setSelectedChart(chart);
	};

	const handleChartNameChange = (event) => {
		setChartName(event.target.value);
	};

	const saveChartWithPrompt = async () => {
		if (!chartName && !selectedChart) {
			alert('Por favor, ingrese un nombre para el gráfico o seleccione uno existente.');
			return;
		}

		setIsSavePopupOpen(false); 
		let response;
		try {
			if (selectedChart && selectedChart !== 'newConfig') {
				response = await saveChart(tvWidget, selectedChart.name, 'PUT', selectedChart);
				toast.success('Gráfico guardado con éxito.');
			} else {
				response = await saveChart(tvWidget, chartName, 'POST', null);
				toast.success('Gráfico guardado con éxito.');
			}
		} catch (error) {
			// Verifica si el error es por alcanzar el número máximo de charts
			if (error.response.data.detail === "You have reached the maximum number of charts (2)") {
				toast.error('No puede crear más de 2 gráficos como usuario normal.');
			} else {
				toast.error('Error al guardar el gráfico:', error);
			}
		}
		console.log(response);
		
	};

	const selectChart = (chart) => {
		if (tvWidget) {
			tvWidget.load(JSON.parse(chart.chart));
		}
		setIsPopupOpen(false);
	};

	return (
		<>
			{isLoading && (
				<div className="loading-overlay">
					<div className="loading-spinner"></div>
				</div>
			)}
			<div ref={chartContainerRef} className={'TVChartContainer'} />
			<div style={{
				position: 'fixed',
				top: "40%",
				left: "50%",
				zIndex: 1000,
				transform: 'translate(-50%, -50%)',
				backgroundColor: 'transparent',
				display: isPopupOpen ? 'flex' : 'none',
				justifyContent: 'center',
				alignItems: 'center',
			}}>
				<div style={{
					width: '400px',
					maxHeight: '80%',
					padding: '20px',
					backgroundColor: '#0E111A',
					borderRadius: '10px',
					boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
					border: '4px solid white',
					overflowY: 'auto'
				}}>
					<h3 className='titulo-popup'>Seleccione un gráfico</h3>

					<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
						<div style={{ flex: 1 }}>
							<h4 className='subtitulo-popup'>Mis Gráficos</h4>
							<ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
								{charts && charts.userCharts && Array.isArray(charts.userCharts) ? (
									charts.userCharts.map((chart, index) => (
										<li key={index} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
											<button
												onClick={() => selectChart(chart)}
												className={`small-popup-button ${selectedChart === chart ? 'selected' : ''}`}
											>
												{`Gráfico: ${chart.name}`}
											</button>
										</li>
									))
								) : (
									<p>No hay gráficos de usuario disponibles.</p>
								)}
							</ul>
						</div>
						<div style={{ flex: 1 }}>
							<h4 className='subtitulo-popup'>Eliminar Configuración</h4>
							<ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
								{charts && charts.userCharts && Array.isArray(charts.userCharts) ? (
									charts.userCharts.map((chart, index) => (
										<li key={index} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
											<button onClick={() => confirmDelete(chart)} className="delete-button">X</button> {/* Botón de eliminar */}
										</li>
									))
								) : (
									<p>No hay gráficos de usuario disponibles.</p>
								)}
							</ul>
						</div>
					</div>

					<h4 className='subtitulo-popup'>Gráficos Admin</h4>
					<ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
						{charts && charts.adminCharts && Array.isArray(charts.adminCharts) ? (
							charts.adminCharts.map((chart, index) => (
								<li key={index} style={{ marginBottom: '10px' }}>
									<button
										className='small-popup-button'
										onClick={() => selectChart(chart)}
									>
										{`Gráfico: ${chart.name}`}
									</button>
								</li>
							))
						) : (
							<p>No hay gráficos de administrador disponibles.</p>
						)}
					</ul>

					<button className='popup-button' onClick={closePopup}>
						Cerrar
					</button>
				</div>

			</div>
			<div style={{
				position: 'fixed',
				top: "40%",
				left: "50%",
				zIndex: 1000,
				transform: 'translate(-50%, -50%)',
				backgroundColor: 'transparent',
				display: isSavePopupOpen ? 'flex' : 'none',
				justifyContent: 'center',
				alignItems: 'center',
			}}>
				<div style={{
					width: '400px',
					padding: '20px',
					backgroundColor: '#0E111A',
					borderRadius: '10px',
					boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
					border: '4px solid white',

				}}>
					<h2 className="titulo-popup">Guardar gráfico</h2>
					<h4 className="subtitulo-popup">Selecciona un gráfico existente para sobrescribir:</h4>
					<ul>
						{charts.userCharts.map((chart, index) => (
							<li key={index}>
								<button
									onClick={() => handleChartSelection(chart)}
									className={`small-popup-button ${selectedChart === chart ? 'selected' : ''}`}
								>
									{chart.name}
								</button>
							</li>
						))}
					</ul>

					<h4 className="subtitulo-popup"> Crear uno nuevo:</h4>
					<li>
						<button onClick={() => setSelectedChart('newConfig')}
							className={`small-popup-button ${selectedChart === 'newConfig' ? 'selected' : ''}`}
						>
							Crear nueva configuracion
						</button>
					</li>
					<br></br>
					<input
						type="text"
						value={chartName}
						onChange={handleChartNameChange}
						placeholder="Nombre del gráfico"
						style={{ width: '100%', marginBottom: '15px', padding: '8px' }}
						className="text-black "
						disabled={selectedChart !== 'newConfig'}
					/>
					<button className="popup-button" onClick={saveChartWithPrompt}>
						Guardar
					</button>
					<button className="popup-button" onClick={() => setIsSavePopupOpen(false)}>
						Cancelar
					</button>
				</div>
			</div>
		</>
	);

}